import * as React from "react";

import { Input } from "~/components/ui/input";
import { Label } from "~/components/ui/label";

interface TimePickerProps {
  value?: Date;
  onChange?: (date: Date | undefined) => void;
  id?: string;
  disabled?: boolean;
  label?: string;
}

export function TimePicker({
  value,
  onChange,
  id,
  disabled = false,
  label = "von",
}: TimePickerProps) {
  const [open, setOpen] = React.useState(false);

  const handleTimeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const timeValue = e.target.value;
    if (!timeValue) return;

    const [hours, minutes] = timeValue.split(":").map(Number);
    const newDate = value ? new Date(value) : new Date();

    newDate.setHours(hours);
    newDate.setMinutes(minutes);
    newDate.setSeconds(0);

    onChange?.(newDate);
  };

  const timeValue = value
    ? `${String(value.getHours()).padStart(2, "0")}:${String(
      value.getMinutes(),
    ).padStart(2, "0")}`
    : "";

  return (
    <div className="flex gap-4 w-full">
      <div className="flex gap-3 grow">
        <Label htmlFor={`"time-picker-${id}"`} className="px-1 min-w-[27px]">
          {label}
        </Label>
        <Input
          type="time"
          id={`"time-picker-${id}"`}
          value={timeValue}
          onChange={handleTimeChange}
          disabled={disabled}
          className="w-full bg-background appearance-none [&::-webkit-calendar-picker-indicator]:hidden [&::-webkit-calendar-picker-indicator]:appearance-none"
        />
      </div>
    </div>
  );
}
